function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { colors } from '../../../theme';
import { zIndex } from '../../../theme/z-index';
import { createOwnUpStyle } from '../../style';
export var OwnUpTableOuterContainerStyle = createOwnUpStyle({
  background: colors.WHITE,
  boxShadow: '1px 2px 5px rgba(50, 50, 50, 0.15)',
  display: 'flex',
  variants: {
    striped: {},
    stickyHeader: {},
    stickyColumn: {},
    roundedCorners: {}
  }
});
export var OwnUpTableInnerContainerStyle = createOwnUpStyle({
  overflow: 'auto',
  margin: '20px 30px',
  flex: 1,
  scrollbarWidth: 'thin',
  variants: {
    striped: {},
    stickyHeader: {},
    stickyColumn: {},
    small: {
      margin: '5px'
    },
    roundedCorners: {}
  }
});
export var OwnUpTableStyle = createOwnUpStyle({
  width: '100%',
  height: '100%',
  borderSpacing: 0,
  variants: {
    striped: {},
    stickyHeader: {},
    stickyColumn: {},
    roundedCorners: {
      border: "1px solid ".concat(colors.GREY),
      borderRadius: '10px'
    }
  }
});
export var OwnUpTableHeaderStyle = createOwnUpStyle({
  backgroundColor: colors.WHITE,
  variants: {
    striped: {},
    stickyHeader: {},
    stickyColumn: {},
    roundedCorners: {
      border: "1px solid ".concat(colors.GREY),
      borderRadius: '10px 10px 0 0'
    }
  }
});
export var OwnUpTableBodyStyle = createOwnUpStyle({
  striped: {},
  stickyHeader: {
    position: 'relative',
    zIndex: zIndex.Default
  },
  stickyColumn: {},
  roundedCorners: {
    borderRadius: '0 0 10px 10px'
  }
});
export var OwnUpTableRowStyle = createOwnUpStyle({
  backgroundColor: colors.WHITE,
  variants: {
    striped: {},
    stickyHeader: {},
    stickyColumn: {},
    roundedCorners: {},
    clickable: {
      '&:hover': {
        backgroundColor: colors.LIGHT_GREEN,
        cursor: 'pointer'
      }
    }
  }
});
var commonCellStyles = createOwnUpStyle({
  textAlign: 'center',
  margin: 'auto',
  padding: '10px 15px',
  overflow: 'hidden',
  backgroundColor: colors.WHITE,
  '&:not(:last-child)': {
    borderRight: "1px solid ".concat(colors.GREY)
  },
  variants: {
    striped: {
      // Enforce striping on every other row in the body.
      '.ou-table__tbody > *:nth-child(odd) > &': {
        backgroundColor: colors.BACKGROUND
      }
    },
    stickyHeader: {},
    stickyColumn: {
      '&:first-child': {
        position: 'sticky',
        left: 0,
        zIndex: zIndex.StickyTableColumn,
        '&.ou-table__th': {
          zIndex: zIndex.StickyTableCorner
        }
      }
    },
    roundedCorners: {
      backgroundColor: 'none',
      borderTop: "1px solid ".concat(colors.GREY),
      borderLeft: 'none',
      borderRight: 'none',
      '&:not(:last-child)': {
        borderRight: 'none'
      },
      '*:last-child > &:first-child': {
        borderRadius: '0 0 0 10px'
      },
      '*:last-child > &:last-child': {
        borderRadius: '0 0 10px 0'
      }
    }
  }
});
export var OwnUpTableHeaderCellStyle = createOwnUpStyle(_objectSpread(_objectSpread({}, commonCellStyles), {}, {
  variants: _objectSpread(_objectSpread({}, commonCellStyles.variants), {}, {
    stickyHeader: {
      position: 'sticky',
      top: 0,
      zIndex: zIndex.StickyTableHeader
    },
    roundedCorners: {
      borderLeft: 'none',
      borderRight: 'none',
      backgroundColor: colors.BACKGROUND,
      borderBottom: "1px solid ".concat(colors.GREY),
      '&:not(:last-child)': {
        borderRight: 'none'
      },
      '&:first-child': {
        borderRadius: '10px 0 0 0'
      },
      '&:last-child': {
        borderRadius: '0 10px 0 0'
      }
    },
    clickable: {
      '&:hover': {
        cursor: 'pointer'
      }
    }
  })
}));
export var OwnUpTableCellStyle = createOwnUpStyle(_objectSpread({}, commonCellStyles));